import PushPin from '@mui/icons-material/PushPin'

export default function RosterItemRenderer({ eventInfo }) {
  const fcEvent = eventInfo.event
  const legendItem = fcEvent?.extendedProps?.legendItem
  const brandNameFirstLetter = legendItem?.clinicBrandName?.[0]
  return (
    <div className="d-flex flex-wrap align-items-start">
      {brandNameFirstLetter && (
        <div
          style={{
            borderRadius: '90px',
            border: '1px solid black',
            aspectRatio: '1',
            width: '22px',
            textAlign: 'center',
          }}
        >
          {brandNameFirstLetter}
        </div>
      )}
      <PushPin sx={{ fontSize: '20px' }} />
      <b>{eventInfo.timeText}</b>
      <i>{eventInfo.event.title}</i>
    </div>
  )
}
